module.exports = __webpack_public_path__ + "img/faq_canada.a9d57d1a.png";